fx.ns("shared.extractors", class BackgroundExtractor extends shared.MediaExtractor {

    constructor(parameters)
    {
        super(parameters);
    }

    process(data, theme_category)
    {
        this._theme_category = theme_category;

        super.process(data);
    }

    onImageExtracted(data)
    {
        let date = new Date();

        let background = new models.Background({
            theme_category_id : this._theme_category.id,
            keywords : "",
            visible : 1,
            width : data.width,
            height : data.height,
            bgcolor : fx.graphics.averageColorFromBase64( data.image ),
            id_lang : fx.service("LangService").current.id
        });

        //background.prop("thumb", data.thumb);
        background.update({"thumb" : data.thumb});
        background.prop("date", date);
        background.prop("file", data.file); 
        background.prop("memory", data.image); 
        background.prop("slug", this._theme_category.slug); 
        background.prop("blob", data.blob);

        this.data.addItem(background);

        this.trigger("background-extracted", background);
    }
   
    

});